import React, { useState } from 'react';
import logoPath from '../assests/logo/logo.png'

const Sidebar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: 'Home', icon: 'fa-home', href: '#home' },
    { label: 'CEO', icon: 'fa-user-tie', href: '#ceo' },
    { label: 'Services', icon: 'fa-layer-group', href: '#services' },
    { label: 'Portfolio', icon: 'fa-briefcase', href: '#portfolio' },
    { label: 'Contact', icon: 'fa-envelope', href: '#contact' },
  ];

  return (
    <>
      {/* MOBILE HEADER - Guaranteed visible on all phones */}
      <div className="lg:hidden fixed top-0 left-0 w-full bg-[#0A1D37] h-16 flex items-center justify-between px-6 z-[70] shadow-md">
        <div className="flex items-center space-x-3">
            <div className="bg-white p-1 rounded-sm shadow-sm">
              <img src={logoPath} alt="Logo" className="w-8 h-8 object-contain" />
            </div>
            <span className="text-white font-black tracking-tighter text-sm uppercase">Ehsan Traders</span>
        </div>
        <button 
          onClick={() => setIsOpen(!isOpen)} 
          className="text-2xl text-white w-10 h-10 flex items-center justify-center focus:outline-none"
        >
          <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>

      {/* MOBILE MENU OVERLAY - Improved responsiveness */}
      <div className={`lg:hidden fixed inset-0 bg-[#0A1D37] z-[65] flex flex-col items-center justify-center transition-all duration-500 ease-in-out ${isOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
        <div className="flex flex-col items-center space-y-8">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              onClick={() => setIsOpen(false)}
              className="text-white text-3xl font-black uppercase tracking-widest hover:text-[#D62828] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>

      {/* DESKTOP SIDEBAR - Kept identical, ensured it hides on small screens */}
      <nav 
        className={`hidden lg:flex fixed left-0 top-0 h-screen bg-white shadow-2xl z-50 transition-all duration-300 border-r border-gray-100 flex-col items-center py-10 ${isHovered ? 'w-64' : 'w-24'}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* LOGO AREA */}
        <div className="mb-12 flex flex-col items-center px-4 w-full">
          <div className="w-14 h-14 flex items-center justify-center mb-3">
             <img 
               src={logoPath} 
               alt="Ehsan Traders" 
               className={`transition-all duration-300 object-contain w-full h-full ${isHovered ? 'scale-110' : 'scale-100'}`} 
             />
          </div>
          <div className={`overflow-hidden transition-all duration-300 flex flex-col items-center ${isHovered ? 'opacity-100 h-10' : 'opacity-0 h-0'}`}>
            <span className="text-[12px] font-black tracking-[0.2em] text-[#0A1D37] whitespace-nowrap">EHSAN TRADERS</span>
            <div className="h-[2px] w-8 bg-[#D62828] mt-1"></div>
          </div>
        </div>

        {/* NAVIGATION ITEMS */}
        <div className="flex flex-col w-full">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              className="flex items-center px-8 py-5 text-gray-500 hover:text-white hover:bg-[#0A1D37] transition-all duration-300 group"
            >
              <div className="w-8 text-center group-hover:text-[#D62828]">
                <i className={`fas ${item.icon} text-xl`}></i>
              </div>
              <span className={`ml-6 uppercase tracking-[0.2em] font-black text-[11px] whitespace-nowrap transition-all duration-300 ${isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
                {item.label}
              </span>
            </a>
          ))}
        </div>

        {/* BOTTOM DECORATION */}
        <div className="mt-auto opacity-20">
             <p className={`text-[10px] font-bold uppercase tracking-widest -rotate-90 transition-opacity duration-300 ${isHovered ? 'opacity-0' : 'opacity-100'}`}>
               Est. 2024
             </p>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;